import type { PayloadAction } from '@reduxjs/toolkit';

import { createSlice } from '@reduxjs/toolkit';

import type { Product } from '../../types/types';

interface AppState {
  products: Product[];
}

// Define the initial state using that type
const initialState: AppState = {
  products: [],
};
export const ProductSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setAllProducts: (state, action: PayloadAction<Product[]>) => {
      state.products = action.payload;
    },
    addProduct: (state, action: PayloadAction<Product>) => {
      state.products = [...state.products, action.payload];
    },
    updateProduct: (state, action: PayloadAction<Product>) => {
      state.products = state.products.map((product) =>
        product.id === action.payload.id ? action.payload : product
      );
    },
  },
});

export const { setAllProducts, addProduct, updateProduct } = ProductSlice.actions;

export default ProductSlice.reducer;
